/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * includes data from old TB Summaries Call, that is not yet available through anypoint
 */
export interface AdditionalTariffInformation { 
    termString?: string;
    hasMira?: boolean;
    guaranteeEndDate?: Date;
}

